export const emojiCategories: { icon: string; emojis: string[] }[] = [
  {
    icon: '😊',
    emojis: [
      '😀','😃','😄','😁','😆','😅','🤣','😂','🙂','😉',
      '😊','😇','🥰','😍','🤩','😘','😋','😛','😜','🤪',
      '🤗','🤭','🤫','🤔','😐','😏','😒','🙄','😬','😌',
      '😔','😪','🤤','😴','😷','🤒','🤕','🤢','🤮','🥵',
      '🥶','🥴','😵','🤯','🤠','🥳','😎','🤓','😕','😟',
      '😮','😳','🥺','😢','😭','😱','😤','😡','🤬','😈',
    ],
  },
  {
    icon: '👋',
    emojis: [
      '👋','🤚','🖐','✋','🖖','👌','🤌','🤏','✌','🤞',
      '🤟','🤘','🤙','👈','👉','👆','👇','☝','👍','👎',
      '✊','👊','🤛','🤜','👏','🙌','👐','🤲','🤝','🙏',
    ],
  },
  {
    icon: '❤',
    emojis: [
      '❤','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔',
      '💗','💖','💝','💘','💕','💞','💓','💌','💋','💯',
      '💢','💥','💫','💦','💤','🔥','✨','🌟','⭐','🌈',
    ],
  },
  {
    icon: '🎉',
    emojis: [
      '🎉','🎊','🎈','🎁','🎀','🎆','🎇','✨','🎄','🎃',
      '🏆','🏅','🥇','🥈','🥉','⚽','🏀','🎾','🎮','🎲',
      '🎵','🎶','🎸','🎹','🎺','🎷','🥁','🎤','🎧','🎬',
    ],
  },
  {
    icon: '🍕',
    emojis: [
      '☕','🍵','🍺','🍻','🥂','🍷','🍸','🍹','🧃','🥤',
      '🍔','🍟','🍕','🌮','🌯','🍣','🍱','🍜','🍝','🍛',
      '🍰','🎂','🍩','🍪','🍫','🍬','🍭','🍿','🧁','🍦',
    ],
  },
  {
    icon: '🐱',
    emojis: [
      '🐶','🐱','🐭','🐹','🐰','🦊','🐻','🐼','🐨','🐯',
      '🦁','🐮','🐷','🐸','🐵','🐔','🐧','🐦','🦄','🐝',
      '🦋','🐌','🐞','🐙','🦀','🐠','🐬','🐳','🌸','🌺',
    ],
  },
]

export const REACTION_EMOJIS = [
  '👍','👎','❤','🔥','😂','😮','😢','😡','🥳','🤔',
  '👏','🙏','💯','✨','😍','😎','🤝','💪','🎉','👀',
]
